<template>
	<promos :display="display" :filters="computeFilters"></promos>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";
	import { useRouter } from "vue-router";
	import promos from "@/components/webComponents/widget/promos/promos.vue";

	export default {
		components: {
			promos
		},
		props: {
			display: {
				type: String,
				default: "description"
			},
			kind: {
				type: String,
				default: "dynamic"
			},
			content: {
				type: String,
				default: "[]"
			},
			options: {
				type: String,
				default: "{}"
			},
			pageId: {
				type: String,
				default: undefined
			},
			pageFilters: {
				type: String,
				default: "{}"
			}
		},
		setup(props, context) {
			const $json = inject("$json");

			const widget = ref({
				kind: props.kind
			});

			const globalFilters = ref({});
			//const filter = ref([]);

			if ($json.packed(props.pageFilters)) {
				globalFilters.value = JSON.parse($json.unpack(props.pageFilters));
			} else {
				globalFilters.value = JSON.parse(props.pageFilters || "{}");
			}

			if ($json.packed(props.content)) {
				widget.value.content = JSON.parse($json.unpack(props.content));
			} else {
				widget.value.content = JSON.parse(props.content || "[]");
			}

			if ($json.packed(props.options)) {
				widget.value.options = JSON.parse($json.unpack(props.options));
			} else {
				widget.value.options = JSON.parse(props.options || "{}");
			}

			const computeFilters = computed(() => {
				if (widget.value?.options?.usePageFilter === true) {
					const rtn = {};
					rtn.kind = widget.value.kind;
					rtn.limit = widget.value.options.limit;
					if (
						globalFilters.value?.ContentFilter?.tags ||
						globalFilters.value?.ContentFilter?.search
					) {
						rtn.options = globalFilters.value.ContentFilter || widget.value.options || {};
					} else {
						rtn.options = globalFilters.value.Parent?.ContentFilter || widget.value.options || {};
					}
					return rtn;
				} else {
					return widget.value;
				}
			});

			return {
				computeFilters
			};
		}
	};
</script>
